import React from "react";
import { type FreefieldInputProps } from "shared/utils/freeFields/models";
import UrlInput from "components/urlinput";

const FreefieldUrl = (props: FreefieldInputProps & { validatorKey: string }) => {
  const [text, setText] = React.useState(props.initialValue ?? "");

  const onChange = (value: string) => {
    setText(value);
    props.onChange(value);
  };

  return <UrlInput
    validatorKey={props.validatorKey}
    value={text}
    onValueChange={onChange}
    maxLength={serverReference.constants.url.maxUrlLength}
  />;
};

export default FreefieldUrl;